<template>
  <portlet
          :icon="'fad fa-file'"
          :title="'Documents'"
          :actionsBlock="true"
  >
    <template slot="portletBody">
       <div id="drop-files"
            @drop="handleDrop"
            @dragover="handleDragOver"
            @dragenter="handleDragEnter"
            @dragleave="handleDragLeave"
            :class="{ 'drag-over': isDragOver }">
        <input type="file" ref="file" style="display: none" v-on:change="(e) => setFile(e)"/>
        <button class="btn btn-primary" @click="$refs.file.click()">Upload Document</button><br/>
        <span class="subtext">Or drag file here</span>
       </div>
       <datatables
        v-if="documents.length && renderedComponent && Can(rights.DOCUMENT_VIEW)"
        :tableClass="tableClass"
        tableID="documents"
        :rows="documents"
        :columns="getColumns()"
        :tableInitOptions="tableInitOptions"
        routerLinkClass="dt-router-link"
        deleteClass="delete"
        clickClass="clickable"
        :customFilters="customFilters"
        @rowSelected="documentClick"
      ></datatables>
       <upload-document
        v-if="Can(rights.DOCUMENT_ADD)"
        ref="uploadModal"
        :value="upload"
        :name="'upload-modal'"
        :category="null"
        :flexworker="null"
        :categories="categories"
        :organizations="organizations"
        :file="file"
        :flexworkers="flexworkers"
        @saveChanges="uploadFile($event)"
      >
      </upload-document>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {dataTables} from '../../components/mixins/dataTables.js';
  import {swalModals} from '../../components/mixins/swalModals.js';
  import uploadDocument from '../../components/documents/uploadDocument.vue'
  import Vue from 'vue';
  import store from '../../store.js';
  import editUser from '../../components/users/editUser.vue';
  import firebase from 'firebase/app';
  import { Can } from '../../../permission/ability.js';
  import { RIGHTS } from '../roles/rights';

  export default {
  components: { editUser, uploadDocument },
    mixins: [dataTables, swalModals],
    data() {
      return {
        rights: '',
        isAdmin: false,
        documents: [],
        categories: [],
        organizations: [],
        user: null,
        nextPageToken: null,
        customFilters: [],
        modalId: null,
        file: null,
        upload: {name: '', rights: []},
        flexworkers: [],
        isDragOver: false
      };
    },
  async   created() {
      this.rights = RIGHTS;
      this.$store.commit('setLoading',true)
     await  this.fetchData();
      this.$store.commit('setLoading',false)
      this.isAdmin = this.$store.state.users.me.admin;
    },
    methods: {
      Can,
      async  fetchData() {
        this.$store.commit('setLoading',true)
        await   store.dispatch('documents/getCategories', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.categories = res.data.data;
            this.nextPageToken = res.nextToken;
          }
        }).catch((err) => {

        });

        store.dispatch('organizations/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.organizations = res.data.data;
          }
        }).catch((err) => {

        });

        store.dispatch('flexworkers/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            this.flexworkers = res.data.data;
          }
        }).catch((err) => {

        });

        await store.dispatch('documents/getAll', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
          if (res.status === 200) {
            let documents = res.data.data
            let employmentDocs = []

            // let's count documents per employment
            let documentLine = []
            documents.map((document, key) => {
                // Index by document UUID
                if(employmentDocs[document.uuid] === undefined) {
                    employmentDocs[document.uuid] = {
                        id: document.id,
                        category: document.category,
                        uuid: document.uuid,
                        amount: 0,
                        file: document.file,
                        organization: document.employment.organization
                    }
                }
                employmentDocs[document.uuid].amount++
            })

            // Prepare the data to be sent to the view
            for (const [key2, document] of Object.entries(employmentDocs)) {
                //console.log(document)
                documentLine.push(document)
            }
            // employmentDocs.map((document, key) => {
            //     console.log("JLKJALKJKLSJLKA")
            //     //for (const [key2, documentCategory] of Object.entries(document['uuid'])) {
            //         documentLine.push({...document})
            //     //}
            // })

            this.documents = documentLine;
            console.log(this.documents)
            this.nextPageToken = res.nextToken;
          }
        }).catch((err) => {

        });

          this.$store.commit('setLoading',false)
      },
      setFile(e) {
        if(e.target.files && e.target.files.length > 0) {
            this.file = e.target.files[0]
        } else {
            this.file = null
        }
      },
      getColumns() {
        let self = this;
        return [
          {data: 'id', name: 'Id', visible: false},
          {data: null, name: 'Name', visible: true, searchable: true, render(data) {
            return '<a class="get-data" href="#">' + data.file.filename + '</a>'
          }},
          {data: null, name: 'Size', visible: true, searchable: true, render(data) {
            return (data.file.size / (1024 * 1024)).toFixed(2) + ' MB'
          }},
          {data: 'category.name', name: 'Category', visible: true, searchable: true},
          {data: null, name: 'Amount', visible: true, searchable: true, render(data) {
            return '<div><span style="font-weight: 600">' + data.organization.name + '</span><br/>' + data.amount + ' Flexworkers</div>'
          }},
        ]
      },
      documentClick(value) {
        this.downloadFile(value.file)
      },
      async downloadFile(file) {
        try {
            const res = await store.dispatch('documents/downloadDocument', {
            ApiClient: Vue.prototype.$ApiClient,
            departments: this.$store.getters.getUserData.departments, 
            hash: file.hash
            });
            if (res.status === 200) {
            const url = URL.createObjectURL(res.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            //this.$set(this.fileUrls, msg.id, url);
            }
        } catch (err) {

        } finally {
            //this.$set(this.fileDownloading, msg.id, false);
        }
      },
      uploadFile(event) {
        const employmentIds = []
        const missing = []
        const flexworkerById = new Map(this.flexworkers.map(f => [f.id, f]))

        event.flexworkers.forEach((flexId) => {
            const flexworker = flexworkerById.get(flexId)
            if (flexworker && flexworker.employment && flexworker.employment.id) {
                employmentIds.push(flexworker.employment.id)
            } else {
                missing.push(flexworker ? flexworker.name : '#' + flexId)
            }
        })

        if (missing.length > 0) {
            this.$toasted.global.failedRequest({
                message: 'De volgende flexworker(s) hebben geen actief dienstverband en kunnen het document niet ontvangen: ' + missing.join(', ')
            })
            return
        }

        store.dispatch('documents/createDocumentBatch', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments, file: this.file, documentCategoryId: event.category, employmentId: employmentIds}).then((res) => {
            if (res && res.status === 200) {
                this.$refs.uploadModal.clearSelection()
                this.$toasted.global.successRequest({
                    message: 'Documenten succesvol gepubliceerd'
                })
                this.fetchData()
                return
            }

            const message = res && res.response && res.response.data && res.response.data.message
                ? res.response.data.message
                : 'Onbekende fout bij uploaden van het document.'
            this.$toasted.global.failedRequest({ message })
        });
      },
             handleDrop(e) {
         e.preventDefault();
         this.isDragOver = false;
         
         const files = e.dataTransfer.files;
         if (files && files.length > 0) {
           this.file = files[0];
         } else {
           this.file = null;
         }
       },
             handleDragOver(e) {
         e.preventDefault();
         e.stopPropagation();
         this.isDragOver = true;
       },
       handleDragEnter(e) {
         e.preventDefault();
         e.stopPropagation();
         this.isDragOver = true;
       },
       handleDragLeave(e) {
         e.preventDefault();
         e.stopPropagation();
         // Only set isDragOver to false if we're leaving the drop zone entirely
         if (!e.currentTarget.contains(e.relatedTarget)) {
           this.isDragOver = false;
         }
        }
    },
    computed: {
      ...mapGetters('roles', ['getRoles']),
    },
    watch: {
        file(newV, oldV) {
            if(newV !== null) {
                console.log(newV)
                $('.modal').modal('show') ;
            }
        }
    }
  };
</script>

<style lang="scss" scoped>
#drop-files {
    background-color: #E7F1F1;
    border: 3px dashed #146F70;
    border-radius: 10px;
    width: 100%;
    height: 150px;
    text-align: center;
    vertical-align: middle;
    padding-top: 4rem;
    margin-bottom: 1rem;
    transition: all 0.3s ease;
    cursor: pointer;
    
    button {
        margin-bottom: 1rem;
    }
    
    .subtext {
        vertical-align: middle;
        color: #2A2A2A;
        font-size: smaller;
    }
    
    &.drag-over {
        border-color: #007bff;
        background-color: #f0f9eb;
        transform: scale(1.02);
        box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
    }
    
    &:hover {
        border-color: #007bff;
        background-color: #f8f9fa;
    }
}
</style>